import {Injectable, signal} from '@angular/core'; // hinzugefügt
import i18next from 'i18next';
import {ValidationMessage} from "./validation-message";

export const REQUIRED = 'required';
export const STRING_LATIN = 'stringLatin';
export const MAX_LENGTH = 'maxlength';
export const MIN_LENGTH = 'minlength';

/**
 * Mapping-Interface: Verknüpft einen Fehler-Key mit einem i18n-Pfad
 */
export interface ValidationMapping {
    /** Control.errors-Key, z.B. 'required' oder 'stringLatin' */
    key: string;
    i18nKey: string;
}

@Injectable({ providedIn: 'root' })
export class ValidationMessagesService {

    readonly languageChanged = signal(i18next.language);

    /**
     * Vordefinierte Standard-Mappings
     */
    private readonly defaultMappings: ValidationMapping[] = [
        { key: REQUIRED, i18nKey: 'sendmail.form.validation.required' },
        { key: STRING_LATIN, i18nKey: 'sendmail.form.validation.string-latin' },
        { key: MAX_LENGTH, i18nKey: 'sendmail.form.validation.maxlength' },
        { key: MIN_LENGTH, i18nKey: 'sendmail.form.validation.minlength' },
    ];

    constructor() { // hinzugefügt
        i18next.on('languageChanged', (lng: string) => {
            this.languageChanged.set(lng);
        });
    }

    /**
     * Gibt für eine Liste von Fehler-Keys ein Array von ValidationMessage zurück.
     * @param errorKeys Liste der Keys aus control.errors
     * @param overrides Optionales Array von ValidationMapping, um Standard-Mappings zu überschreiben
     */
    getMessages(
        errorKeys: string[],
        overrides?: ValidationMapping[]
    ): ValidationMessage[] {
        // Basis-Map aus key → i18nKey
        const map = new Map<string, string>();
        this.defaultMappings.forEach(m => map.set(m.key, m.i18nKey));
        if (overrides) {
            overrides.forEach(o => map.set(o.key, o.i18nKey));
        }

        // Erzeuge das Ergebnis mit Übersetzung
        return errorKeys
            .filter(key => map.has(key))
            .map(key => ({
                key,
                message: i18next.t(map.get(key))
            }) as ValidationMessage);
    }
}


